'use strict';
export const SET_USERINFO = 'SET_USERINFO';
export const UPDATE_USERINFO = 'UPDATE_USERINFO';
export const CLEAR_USERINFO = 'CLEAR_USERINFO';
export const SET_PERMIT_RESOURCES = 'SET_PERMIT_RESOURCES';
